const awsconfig = {
  Auth: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_DxE5spMLz',
    userPoolWebClientId: '3uvkq8rdp6rml6lh8aaisqcrsk',
    mandatorySignIn: false,
  }
};

export default awsconfig;